"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var CollapsePanel = function CollapsePanel(props) {
  var _classnames;
  var className = props.className,
    style = props.style,
    id = props.id,
    children = props.children,
    icon = props.icon,
    label = props.label,
    disabled = props.disabled,
    open = props.open,
    onClick = props.onClick,
    _props$cantOpen = props.cantOpen,
    cantOpen = _props$cantOpen === void 0 ? false : _props$cantOpen;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('collapse__panel');
  var classes = (0, _classnames2.default)(prefixCls, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, 'is-disabled', !!disabled), (0, _defineProperty2.default)(_classnames, 'is-open', !!open), _classnames));
  var handleClick = function handleClick(evt) {
    if (typeof onClick === 'function') {
      onClick(evt, {
        id: id,
        icon: icon,
        label: label,
        open: !open
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "".concat(prefixCls, "-hd ").concat(cantOpen ? 'cantOpen' : ''),
    onClick: handleClick
  }, icon && /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "-icon"),
    style: {
      backgroundImage: "url(".concat(icon, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-title")
  }, label)), children && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-bd")
  }, children));
};
var _default = exports.default = CollapsePanel;